// extracted by mini-css-extract-plugin
module.exports = {"root":"Choice_root__34axY","dragIcon":"Choice_dragIcon__2zYI5","left":"Choice_left__1ap8Y","input":"Choice_input__2FlW7"};